import { gql } from "@apollo/client";

const DISPATCHER_FIELDS = `
  id
  name
  active
  routes
  sources
  targets {
    id
    share
    counts
    organization {
      id
      name
    }
  }
`;

export const DISPATCHERS = gql`
  query Dispatchers(
    $where: DispatcherWhereInput
    $like: DispatcherWhereInput
    $take: Int
    $skip: Int
  ) {
    dispatchers(where: $where, like: $like, take: $take, skip: $skip) {
      data {
        ${DISPATCHER_FIELDS}
      }
      count
    }
  }
`;

export const DISPATCH_ORGANIZATIONS = gql`
  query DispatchOrganizations($where: OrganizationWhereInput) {
    organizations(where: $where) {
      data {
        id
        name
      }
    }
  }
`;

export const DISPATCH_LOGS = gql`
  query DispatchLogs($where: DispatchLogWhereInput, $take: Int, $skip: Int) {
    dispatchLogs(where: $where, take: $take, skip: $skip) {
      data {
        id
        createdDate
        status
        route
        code
        httpStatus
        durationMs
        attempts
        url
        organization
      }
      count
    }
  }
`;

export const DISPATCH_SOURCES = gql`
  query DispatchSources($where: TracerWhereInput, $take: Int) {
    tracers(where: $where, take: $take) {
      data {
        id
        source {
          name
        }
      }
    }
  }
`;

export const DISPATCH_CHILDREN = gql`
  query DispatchChildren {
    dispatchChildren {
      id
      name
      hosting
      environmentUrl
      environmentReady
    }
  }
`;

const dispatchers = {
  DISPATCH_CHILDREN,
  DISPATCHERS,
  DISPATCH_ORGANIZATIONS,
  DISPATCH_LOGS,
  DISPATCH_SOURCES,
};

export default dispatchers;
